import React from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";

import { api } from "@/utils/api";
import url from "@/utils/url";
import { getCompanyInfo as getCompanyInfoDispatch } from "@/models/user";
import ArticleItem from "@/react-components/ArticleItem";
import EmptyResult from "@/react-components/EmptyResult";
import NewsHeader from "@/react-components/NewsHeader";
import PickUp from "@/react-components/PickUp";
import LoadMore from "@/react-components/LoadMore";
import ShowNextPage from "@/react-components/ShowNextPage";
import config from "@/utils/config";

class MypageResearchInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sectionList: [],
    };
  }

  componentDidMount() {
    const { getCompanyInfo } = this.props;
    getCompanyInfo();
  }

  componentDidUpdate(prevProps) {
    const { companyInfo } = this.props;
    if (prevProps.companyInfo !== companyInfo) {
      this.fetchTagList();
    }
  }

  // get tag list
  fetchTagList = () => {
    api.dictionary
      .getTagFirstList()
      .then((response) => {
        const sectionList = response.map((item, index) => {
          let path;
          switch (index) {
            case 0:
              path = url.mypageResearchTips;
              break;
            case 1:
              path = url.mypageResearchEconomy;
              break;
            default:
              path = url.mypageResearchIndustry;
              break;
          }
          return {
            catagoryid: item.itemid,
            text: item.text,
            path,
          };
        });
        this.fetchData(sectionList);
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  fetchData = (sectionList) => {
    const { companyInfo } = this.props;
    const requestList = sectionList.map((item) =>
      api.mypage.getList(
        {
          catagoryID: item.catagoryid,
          pageIndex: 1,
          pageSize: 4,
        },
        { tagIds: JSON.stringify(companyInfo || "") },
        null,
        { catagoryID: item.catagoryid }
      )
    );
    Promise.all(requestList)
      .then((results) => {
        if (results.length > 0) {
          sectionList.forEach((item) => {
            item.list = results.filter(
              (item1) => item1.catagoryID === item.catagoryid
            )[0].list;
          });
          this.setState({ sectionList });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  render() {
    const { sectionList } = this.state;
    const { t } = this.props;
    return (
      <div className="main-content-area">
        <div className="my-page-research-info-container">
          {sectionList.map((item, index) => {
            let key;
            switch (index) {
              case 0:
                key = "TCMS01025_searchResult_tips";
                break;
              case 1:
                key = "TCMS01025_searchResult_economy";
                break;
              default:
                key = "TCMS01025_searchResult_industry";
                break;
            }
            const emptyText = t(key);
            const to = {
              pathname: item.path,
              state: {
                category: { id: item.catagoryid, text: item.text },
                emptyText,
              },
            };
            return (
              <section className="section-container" key={index}>
                <NewsHeader
                  title={item.text}
                  showSubTitle={false}
                  to={to}
                  showMore={false}
                />
                {item.list && (
                  <React.Fragment>
                    {item.list.length > 0 ? (
                      <React.Fragment>
                        <div className="section-content">
                          {item.list.map((item1, index1) => (
                            <ArticleItem key={index1} articles={item1} />
                          ))}
                        </div>
                        <LoadMore to={to} />
                        <ShowNextPage to={to} />
                      </React.Fragment>
                    ) : (
                      <EmptyResult text={emptyText} />
                    )}
                  </React.Fragment>
                )}
              </section>
            );
          })}
        </div>
        {config.pickUpDisplay && (
          <div className="my-page-research-info-pickup-area">
            <PickUp />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    companyInfo: state?.user?.companyInfo,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCompanyInfo: () => dispatch(getCompanyInfoDispatch()),
  };
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(MypageResearchInfo)
);
